import { required } from "vuelidate/lib/validators";
import { Model } from "./Model";
import { Estado, EstadoValidation, EstadoNoValidation } from "./Estado";

class Municipio extends Model {
  constructor() {
    super();
    this.estado = new Estado();
    this.nome = "";
  }
}

const MunicipioValidation = {
  estado: EstadoValidation,
  nome: {
    required,
  },
};

const MunicipioNoValidation = {
  estado: EstadoNoValidation,
  nome: {},
};

export { Municipio, MunicipioValidation, MunicipioNoValidation };
